import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import IssuePreviewModalContainer from '../project-view/IssuePreviewModalContainer';
import IssueAttachmentGalleryContainer from '../issues/IssueAttachmentGalleryContainer';

class IssueDetailsModalView extends PureComponent {
  componentWillReceiveProps(nextProps) {
    if (!this.props.hasViolation && nextProps.hasViolation) {
      this.props.closeIssueDetailsModalViewEventTriggerAction();
    }
  }

  render() {
    return (
      <div className="IssueDetailsModalView">
        <IssuePreviewModalContainer
          container={this}
          issueId={this.props.issueId}
          isModalOpen
          onClose={this.props.closeIssueDetailsModalViewEventTriggerAction}
        />
        <IssueAttachmentGalleryContainer container={this} />
      </div>
    );
  }
}

IssueDetailsModalView.displayName = 'IssueDetailsModalView';

IssueDetailsModalView.propTypes = {
  issueId: PropTypes.string.isRequired,
  closeIssueDetailsModalViewEventTriggerAction: PropTypes.func.isRequired,
  hasViolation: PropTypes.bool
};

export default IssueDetailsModalView;
